import { useEffect, useRef, useState } from "react";
import { GetDeviceByFilter, GetAllOrg, GetAllVersions } from "../Api";
import {
  Box,
  Grid,
  IconButton,
  Input,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DataTable from "react-data-table-component";
import DeviceDetailSlider from "../DeviceDetailSlider";
import Spinner from "../Spinner";
import { Settings } from "lucide-react";
import DeviceSettings from "./DeviceSettings";

interface Props {
  isWithOrg: boolean;
}

export default function DeviceCustomFunction({ isWithOrg }: Props) {
  const isLoading = useRef(true);
  const parentRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [parentWidth, setParentWidth] = useState(0);

  const [versions, setVersions] = useState<any>();

  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({ open: false, message: "", severity: "success" });

  // const [snackbar, setSnackbar] = useState<{
  //   open: boolean;
  //   message: string;
  //   severity: "success" | "error";
  // }>({ open: false, message: "", severity: "success" });

  const [selectedDevice, setSelectedDevice] = useState<any>(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [overAllDeviceCount, setOverAllDeviceCount] = useState(0);
  const [overAllConnectedCount, setOverAllConnectedCount] = useState(0);

  const [organizations, setOrganizations] = useState<any>();
  const [spinner, setSpinner] = useState(false);

  const [totalCount, setTotalCount] = useState<number>(0); // 👈 for paginationTotalRows
  const [page, setPage] = useState<number>(1); // current page
  const [limit, setLimit] = useState<number>(10); // per-page limit
  const [search, setSearch] = useState<string>(""); // for search const [totalPages, setTotalPages] = useState<number>(1);
  const [allDevices, setAllDevices] = useState<any[]>([]);
  const [filteredDevices, setFilteredDevices] = useState<any[]>([]);
  const [setting, setSetting] = useState<string>("");
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleLimitChange = (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage); // reset page when limit changes
  };
  const getOrgAndVersionsList = async () => {
    const versionsResult = await GetAllVersions();
    setVersions(versionsResult);
    const org = await GetAllOrg();
    // const org = await ();
    setOrganizations(org);
  };

  useEffect(() => {
    getOrgAndVersionsList();
    fetchData(); // Fetch data initially
    const interval = setInterval(() => {
      getOrgAndVersionsList();
      fetchData(); // fetch every 5 seconds
    }, 10000);

    return () => clearInterval(interval); // cleanup on unmount or dependency chan
  }, [search, page, limit]);

  useEffect(() => {
    if (parentRef.current) {
      var parentCurrent: any = parentRef.current;
      setParentWidth(parentCurrent?.clientWidth);
    }
  }, [parentRef]);

  async function fetchData() {
    if (isLoading.current) {
      setSpinner(true);
      // const org = await GetAllOrg();
      // setOrganizations(org)

      // const versionsResult = await GetAllVersions();
      // setVersions(versionsResult);
    }
    try {
      const result: any = await GetDeviceByFilter({
        page,
        limit,
        search,
      });
      // let filterWithoutOrg;
      // if (isWithOrg) {
      //   filterWithoutOrg = result.filter((obj: any) =>
      //     obj.organization ? obj.organization !== "" : false
      //   );
      // } else {
      //   filterWithoutOrg = result.filter((obj: any) =>
      //     obj.organization ? obj.organization === "" : true
      //   );
      // }

      // Store all devices
      setAllDevices(result.devices);
      setTotalCount(result.total); //
      setOverAllDeviceCount(result.overAllDeviceCount ?? 0);
      setOverAllConnectedCount(result.overAllConnectedCount ?? 0);
      isLoading.current = false;
      setSpinner(false);
    } catch (error) {
      isLoading.current = false;
      setSpinner(false);
      console.log("Error:", error);
    }
  }

  // const applySearchFilter = (devices: any[]) => {
  //   const filtered = devices.filter((obj: any) =>
  //     [
  //       obj.deviceID,
  //       obj.mac_address,
  //       obj.firmwareVersion,
  //       obj.tags?.join(" "),
  //       obj.organization,
  //     ].some((value) =>
  //       value?.toLowerCase().includes(searchQuery.toLowerCase())
  //     )
  //   );
  //   setFilteredDevices(filtered);
  // };

  // useEffect(() => {
  //   applySearchFilter(allDevices);
  // }, [searchQuery, allDevices]);

  const col = [
    {
      name: "Device Id",
      selector: (row: any) => row?.deviceID,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.deviceID}
        </div>
      ),
    },
    {
      name: "Device Mac Address",
      selector: (row: any) => row?.mac_address,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.mac_address}
        </div>
      ),
    },
    {
      name: "Installation Time",
      selector: (row: any) => row?.installationTime,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.installationTime}
        </div>
      ),
    },
    {
      name: "Firmware Version",
      selector: (row: any) => row?.firmwareVersion,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.firmwareVersion}
        </div>
      ),
    },
    {
      name: "Organization",
      selector: (row: any) => row?.organization,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
        >
          {row?.organization ?? "-"}
        </div>
      ),
    },
    {
      name: "Device Status",
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
            color: row?.deviceStatus ? "green" : "black",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.deviceStatus === true ? "Connected" : "Disconnected"}
        </div>
      ),
    },

    {
      name: "Action",
      cell: (row: any) => {
        return (
          <IconButton edge="end" aria-label="delete">
            <Settings
              color="black"
              onClick={() => setSetting(row.deviceID)}
            />
          </IconButton>
        );
      },
    },
  ];

  const totalDevices = Array.isArray(allDevices) ? allDevices.length : 0;
  const connectedDevices = Array.isArray(allDevices)
    ? allDevices.filter((d) => d?.deviceStatus).length
    : 0;

  return (
    <>
      {setting === "" ? (
        <Box sx={{ fontFamily: "Arial, sans-serif", p: 2 }}>
          <Spinner running={spinner} />
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              gap: 2,
            }}
            flexDirection={"column"}
            ref={parentRef}
          >
            <Grid
              container
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"1rem"}
            >
              <Box>
                <Typography fontSize={isMobile ? "0.8rem" : "1rem"}>
                  Connected: <strong>{overAllConnectedCount}</strong>/
                  <strong>{overAllDeviceCount}</strong>
                </Typography>
              </Box>
              <Input
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  fetchData();
                }}
                style={{
                  width: isMobile || isTablet ? "100%" : "250px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              />
            </Grid>

            <div
              style={{
                flex: 1,
                width: parentWidth,
              }}
            >
              <DataTable
                columns={col}
                data={allDevices}
                pagination
                paginationServer
                paginationTotalRows={totalCount} // total from backend
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitChange}
                paginationPerPage={limit}
                paginationDefaultPage={page}
                style={{ height: "70vh", width: "0vh !important" }}
                customStyles={{
                  rows: {
                    style: {
                      overflow: "visible", // Ensure rows are not clipped
                    },
                  },
                  cells: {
                    style: {
                      whiteSpace: "normal", // Allows text to wrap
                      overflow: "visible", // Ensures text is visible
                    },
                  },
                }}
              />
            </div>
          </Grid>
          <DeviceDetailSlider
            open={isSliderOpen}
            onClose={() => setIsSliderOpen(false)}
            device={selectedDevice}
            setSelectedDevice={setSelectedDevice}
            setSnackbar={setSnackbar}
          />
        </Box>
      ) : (
        <Box p={"1rem"}>
          {/* The DeviceSettings component is now outside the flex container, */}
          {/* so it will render below the button as a normal block element. */}
          <DeviceSettings deviceId={setting} setSetting={setSetting} />
        </Box>
      )}
    </>
  );
}
